import React from "react";

const fmtTime12 = (v) => {
  const s = String(v || "");
  const t = s.includes("T") ? s.split("T")[1] : (s.includes(" ") ? s.split(" ")[1] : s);
  const hhmm = String(t || "").slice(0, 5);
  if (!/^[0-2][0-9]:[0-5][0-9]$/.test(hhmm)) return hhmm || "";
  let h = Number(hhmm.slice(0, 2));
  const m = hhmm.slice(3, 5);
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${m} ${ampm}`;
};

const CalendarDayView = ({
  anchorDate,
  apptsByDate,
  todayYMD,
  openNewForDate,
  openEdit,
  fmtYMD,
  fmtFriendly,
  styles,
}) => {
  const key = fmtYMD(anchorDate);
  const list = apptsByDate[key] || [];
  const isToday = key === todayYMD;

  return (
    <div style={styles.board}>
      <div style={styles.boardInner}>
        <div style={{ ...styles.dayColHeader(isToday), borderRadius: 12 }}>
          <div>{fmtFriendly(anchorDate)}</div>
        </div>

        <div style={{ padding: "12px 12px 120px", display: "flex", flexDirection: "column", gap: 10 }} onClick={() => openNewForDate(anchorDate)}>
          {list.length ? (
            list.map((a) => (
              <div key={a.id} style={{ ...styles.apptCard(a.job_type_color, a.employee_color), width: "100%", maxWidth: 640 }} onClick={(e) => { e.stopPropagation(); openEdit(a); }}>
                <div style={styles.empStripe(a.employee_color)} />
                <div style={styles.apptTitle}>
                  {fmtTime12(a.start_hhmm || a.start_time)}–{fmtTime12(a.end_hhmm || a.end_time)} • {String(a.customer_name || "").trim() || "(customer)"}
                </div>
                <div style={styles.apptSub}>
                  {String(a.employee_name || "").trim() ? `👤 ${String(a.employee_name).trim()}` : ""}
                  {String(a.job_type_name || "").trim() ? ` • 🧰 ${String(a.job_type_name).trim()}` : ""}
                  {a.estimate_on_file ? " • ✅ ESTIMATE" : ""}
                </div>
                {a.isMultiDay ? (
                  <div style={styles.apptSub}>
                    {a.isSpanStart
                      ? `📅 MULTI-DAY → through ${fmtFriendly(new Date(a._endDate + "T00:00:00"))}`
                      : a.isSpanEnd
                      ? `📅 FINAL DAY — started ${fmtFriendly(new Date(a._startDate + "T00:00:00"))}`
                      : `📅 CONTINUES → ends ${fmtFriendly(new Date(a._endDate + "T00:00:00"))}`}
                  </div>
                ) : null}
              </div>
            ))
          ) : (
            <div style={{ fontWeight: 900, opacity: 0.9 }}>No appointments.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CalendarDayView;